const config = {
  id: 26,
  name: '品牌日 二',
  type: 1,
  module_code: 'active_day2', // bind的配置文件
  icon: 'icon-tms-red-packet',
  font_icon: '&#xe608;',
  style_type: 1,
  link_type: 0,
  property_data: {
    type: 1,
    background_url: 'https://mktv-in-cdn.mockuai.com/16396429412357879.png',
    title_color: '#FE7381',
    subtitle_bg_color: '#FC7E77',
    btn_lf_text_color: '#fff',
    btn_rt_text_color: '#fff',
    btn_lf_bg: ['#1361C3', '#1999EB'],
    btn_rt_bg: ['#F24038', '#F89A97'],
    list: [],
    sale_bg_color: '#1351B7',
    sale_color: '#FFFEFE',
    margin_number: 0
  }
};

export default config;


